module.exports = __webpack_public_path__ + "FixelText-Bold.8bad1d7055a6f6c99d6a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelText/FixelText-Bold.woff2
// module id = ./src/assets/webfonts/fixelText/FixelText-Bold.woff2
// module chunks = styles